import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Radium from "radium";

import domtoimage from "dom-to-image";
import jsPDF from "jspdf";

import { semanticColors } from "../../../Globals/styles";
import { Scrollbars } from "react-custom-scrollbars";
import { dateToString, dateToStringNoDays } from "../../../Util/dateTime";
import { absenceCodes } from "../../../Globals/constants";
import * as actions from "./actions";

import HeadingSubtextContainer from "../../../HeadingSubtext/HeadingSubtextContainer";
import InvoiceSummary from "./summary";
import StaticDailyReport from "../DailyReport/staticDailyReport2";

import { httpGet, httpPost } from "../../../Util/http";

import Offers from "./spreadsheets/offers";
import Others from "./spreadsheets/others";
import Crew from "./spreadsheets/crew";
import Activity from "./spreadsheets/activity";
import Materiel from "./spreadsheets/materiel";
import Measurements from "./spreadsheets/measurements";
import DeliveryNotes from "./spreadsheets/deliveryNotes";
import Invoices from "./spreadsheets/invoices";

/* eslint import/no-webpack-loader-syntax: off */
import ch from "!raw-loader!../../../../css/main.css";

class StaticInvoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hide: true,
      document: null,
      showDailyreports: false,
    };
  }

  renderStringWithLines = (string) => {
    return string.split("\n").map((subString, index) => {
      return (
        <span key={index}>
          {index !== 0 ? <br /> : null}
          {subString}{" "}
        </span>
      );
    });
  };
  addColon = (time) => {
    if (time.indexOf(":") > -1) {
      return time;
    }
    time = time.replace(",", "");
    time = time.replace(".", "");
    time = time.replace(" ", "");
    return time.slice(0, 2) + ":" + time.slice(2);
  };
  render() {
    const { stamdata, ceas } = this.props;
    let today = new Date();
    return (
      <div
        style={{
          width: "100%",
        }}
      >
        <div
          style={{
            position: "fixed",
            top: 50,
            left: 10,
            zIndex: 999,
            width: 400,
            "@media print": {
              display: "none",
            },
          }}
        >
          {this.props.saved ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
              }}
            >
              {this.props.deleted == "goahead" ? (
                <div style={{ paddingTop: 10 }}>
                  <span
                    style={{ cursor: "pointer", paddingRight: 5 }}
                    onClick={() => {
                      this.props.dispatch(actions.markDeleted("false"));
                    }}
                  >
                    Annuller
                  </span>
                  |
                  <span
                    style={{ cursor: "pointer", paddingLeft: 5 }}
                    onClick={() => {
                      this.props.dispatch(actions.markDeleted(true));
                      this.props.dispatch(
                        actions.saveChanges(this.props.workplaceId)
                      );

                      setTimeout(() => {
                        window.location.reload();
                      }, 500);
                    }}
                  >
                    Klik for at slette
                  </span>
                </div>
              ) : (
                <div>
                  <button
                    className="btn btn-primary"
                    style={{ borderRadius: 0 }}
                    onClick={() => {
                      var newWindow = window.open();
                      newWindow.document.write(
                        '<html><head><title>Estimat</title><script src="https://use.fontawesome.com/9800e75fd3.js"></script><style>' +
                          ch +
                          "</style><style>@media print {.hidethis {display: none;}}</style></head>"
                      );
                      newWindow.document.write(this.invoice.innerHTML);
                      setTimeout(() => {
                        newWindow.print();
                        newWindow.close();
                      }, 1500);
                    }}
                  >
                    Print
                  </button>
                  <button
                    style={{ borderRadius: 0 }}
                    className="btn btn-primary"
                    onClick={() => {
                      this.props.dispatch(actions.zipIt());
                    }}
                  >
                    Hent billeder/bilag
                  </button>
                  <button
                    className="btn btn-primary"
                    style={{ borderRadius: 0 }}
                    onClick={() => {
                      this.props.dispatch(actions.zipDatasheets());
                    }}
                  >
                    Hent datablade
                  </button>
                  <button
                    style={{ borderRadius: 0, marginLeft: 3 }}
                    className="btn btn-danger"
                    onClick={() => {
                      this.props.dispatch(actions.markDeleted("goahead"));
                    }}
                  >
                    Slet
                  </button>
                </div>
              )}
            </div>
          ) : this.props.invoiceId ? (
            <div>
              <button
                className="btn btn-primary"
                style={{ borderRadius: 0 }}
                onClick={() => {
                  this.props.dispatch(
                    actions.saveChanges(this.props.workplaceId)
                  );
                  this.props.savee();
                }}
              >
                {"Gem ændringer"}
              </button>
              <button
                className="btn btn-primary"
                style={{ borderRadius: 0 }}
                onClick={() => {
                  var printContents = "";
                  this.props.dispatch(
                    actions.printInvoice(this.props.workplaceId, printContents)
                  );
                  this.props.savee();
                }}
              >
                {"Gem som ny faktura"}
              </button>
            </div>
          ) : (
            <button
              className="btn btn-success"
              onClick={() => {
                var printContents = "";
                this.props.dispatch(
                  actions.printInvoice(this.props.workplaceId, printContents)
                );
                this.props.savee();
              }}
            >
              {"Gem & Afslut"}
            </button>
          )}
        </div>

        <div
          ref={(invoice) => (this.invoice = invoice)}
          style={styles.container}
        >
          <div style={styles.contentContainer}>
            <div
              style={{
                minHeight: "25cm",
                pageBreakAfter: "always",
              }}
            >
              <div>
                <img
                  alt="billede"
                  style={styles.logo}
                  src="/images/CE-logo-NYT-75.jpg"
                />
                <div style={styles.entityContainer}>
                  <div
                    className="row"
                    style={[styles.doubleLine, styles.firstRow]}
                  >
                    <h3 style={styles.heading.left}>Estimat</h3>
                    <div style={[styles.heading.left, styles.date]}>
                      {dateToString(today)}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                {this.props.dates.start ? (
                  <div style={{ textAlign: "center" }}>
                    Perioden{" "}
                    {dateToStringNoDays(new Date(this.props.dates.start))} -{" "}
                    {dateToStringNoDays(new Date(this.props.dates.end))}
                  </div>
                ) : null}
                <page>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <HeadingSubtextContainer
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        width: 220,
                      }}
                      updateSubtext={(text, index) =>
                        this.props.dispatch(
                          actions.updateSubtext_ExtraInfo(text, index)
                        )
                      }
                      updateHeading={(text, index) =>
                        this.props.dispatch(
                          actions.updateHeading_ExtraInfo(text, index)
                        )
                      }
                      addHeadingSubtext={() =>
                        this.props.dispatch(
                          actions.addHeadingSubtext_ExtraInfo()
                        )
                      }
                      headingSubtexts={stamdata}
                      dontAllowNewRow
                    />
                    <HeadingSubtextContainer
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        width: 220,
                      }}
                      subtextStyle={{ textAlign: "right" }}
                      headingStyle={{
                        textAlign: "right",
                        height: "auto",
                        paddingBottom: 0,
                      }}
                      updateSubtext={(text, index) =>
                        this.props.dispatch(
                          actions.updateSubtext_ceas(text, index)
                        )
                      }
                      updateHeading={(text, index) =>
                        this.props.dispatch(
                          actions.updateHeading_ceas(text, index)
                        )
                      }
                      addHeadingSubtext={() =>
                        this.props.dispatch(actions.addHeadingSubtext_ceas())
                      }
                      headingSubtexts={ceas}
                      dontAllowNewRow
                    />
                  </div>
                </page>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    paddingTop: 50,
                  }}
                >
                  <div
                    style={{
                      padding: 10,
                      border: "2px solid lightgrey",
                      height: 250,
                      width: 425,
                    }}
                  >
                    <h3
                      style={{
                        padding: 10,
                        textAlign: "center",
                        borderBottom: "1px solid grey",
                      }}
                    >
                      Sum
                    </h3>
                    <InvoiceSummary
                      others={this.props.others}
                      usage={this.props.usage}
                      crew={this.props.employeeHoursCalc.calcs}
                      offers={this.props.offers}
                      measurements={this.props.measurements}
                      activities={this.props.activities}
                      deliveryNotes={this.props.deliveryNotes}
                      invoices={this.props.invoices}
                    />
                    <div style={{ textAlign: "center", fontSize: 12 }}>
                      Alle priser er ekskl. moms
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={this.props.descr ? "" : "hidethis"}
              style={{
                pageBreakBefore: "auto",
                paddingBottom: 50,
              }}
            >
              <div
                className="hidethis"
                style={{
                  paddingBottom: 35,
                  backgroundColor: "rgb(247, 247, 247)",
                  width: "200%",
                  marginLeft: -35,
                }}
              ></div>
              <h3
                style={{
                  padding: 20,
                  textAlign: "center",
                  borderBottom: "1px solid grey",
                }}
              >
                Beskrivelse
              </h3>
              <textarea
                style={{
                  marginTop: 10,
                  resize: "none",
                  width: "100%",
                  border: "none",
                  outline: "none",
                  paddingLeft: 5,
                  height: 60,
                  boxShadow:
                    "rgba(0, 0, 0, 0.2) 0px 1px 2px inset, rgba(0, 0, 0, 0.05) 0px -1px 0px inset",
                  "-webkit-appearance": "none",
                }}
                value={this.props.descr ? this.props.descr : ""}
                onChange={(e) =>
                  this.props.dispatch({
                    type: "TILBUD_DESC",
                    value: e.target.value,
                  })
                }
              />
            </div>

            {this.props.offers && this.props.offers.length > 0 ? (
              <div
                style={{
                  pageBreakBefore: "auto",
                  pageBreakInside: "avoid",
                  paddingBottom: 50,
                }}
              >
                <div
                  className="hidethis"
                  style={{
                    paddingBottom: 35,
                    backgroundColor: "rgb(247, 247, 247)",
                    width: "200%",
                    marginLeft: -35,
                  }}
                ></div>
                <h3
                  style={{
                    padding: 20,
                    textAlign: "center",
                    borderBottom: "1px solid grey",
                  }}
                >
                  Øvrige
                </h3>
                <Offers
                  id={this.props.offersId}
                  rows={this.props.offers}
                  offersKey={this.props.offersKey}
                  update={(index, offer) =>
                    this.props.dispatch(actions.updateOfferRow(index, offer))
                  }
                />
              </div>
            ) : null}

            {this.props.employeeHoursCalc.calcs &&
            Object.keys(this.props.employeeHoursCalc.calcs)
              .map((k) => this.props.employeeHoursCalc.calcs[k].sum)
              .some((element, index, array) => {
                return !isNaN(parseFloat(element)) || element > 0;
              }) ? (
              <div
                style={{
                  width: "100%",
                  pageBreakBefore: "auto",
                  pageBreakInside: "avoid",
                  paddingBottom: 50,
                }}
              >
                <div
                  className="hidethis"
                  style={{
                    paddingBottom: 35,
                    backgroundColor: "rgb(247, 247, 247)",
                    width: "200%",
                    marginLeft: -35,
                  }}
                ></div>
                <h3
                  style={{
                    padding: 20,
                    textAlign: "center",
                    borderBottom: "1px solid grey",
                  }}
                >
                  Mandskab
                </h3>
                <Crew
                  dontRenderEmpty
                  rows={this.props.employeeHoursCalc.calcs}
                  update={(fun, obj) =>
                    this.props.dispatch(
                      actions.updateEmployeeFunction(fun, obj)
                    )
                  }
                  recalc={() => this.props.dispatch(actions.recalcEmployee())}
                  crewKey={this.props.crewKey}
                  open
                />
              </div>
            ) : null}
            {this.props.activities && this.props.activities.length > 0 ? (
              <div
                style={{
                  width: "100%",
                  pageBreakBefore: "auto",
                  pageBreakInside: "avoid",
                  paddingBottom: 50,
                }}
              >
                <div
                  className="hidethis"
                  style={{
                    paddingBottom: 35,
                    backgroundColor: "rgb(247, 247, 247)",
                    width: "200%",
                    marginLeft: -35,
                  }}
                ></div>
                <h3
                  style={{
                    padding: 20,
                    textAlign: "center",
                    borderBottom: "1px solid grey",
                  }}
                >
                  Aktiviteter
                </h3>
                <Activity
                  rows={this.props.activities}
                  activitiesKey={this.props.activitiesKey}
                  update={(index, activity) =>
                    this.props.dispatch(
                      actions.updateActivityRow(index, activity)
                    )
                  }
                />
              </div>
            ) : null}
            {this.props.usage &&
            this.props.usage.filter((e) => e.type == "Materiel").length > 0 ? (
              <div
                style={{
                  width: "100%",
                  pageBreakBefore: "auto",
                  pageBreakInside: "avoid",
                  paddingBottom: 50,
                }}
              >
                <div
                  className="hidethis"
                  style={{
                    paddingBottom: 35,
                    backgroundColor: "rgb(247, 247, 247)",
                    width: "200%",
                    marginLeft: -35,
                  }}
                ></div>
                <h3
                  style={{
                    padding: 20,
                    textAlign: "center",
                    borderBottom: "1px solid grey",
                  }}
                >
                  Materiel
                </h3>
                <Materiel
                  addMateriel={(suggestion) => {}}
                  rows={this.props.usage}
                  materiels={this.props.materiels}
                  materielsKey={this.props.usageKey}
                  type="Materiel"
                  update={(materiel, index) =>
                    this.props.dispatch(actions.updateMateriel(materiel, index))
                  }
                  productDiscounts={this.props.productDiscounts}
                  noPopup
                />
              </div>
            ) : null}
            {this.props.usage &&
            this.props.usage.filter((e) => e.type == "Materiale").length > 0 ? (
              <div
                style={{
                  width: "100%",
                  pageBreakBefore: "auto",
                  pageBreakInside: "avoid",
                  paddingBottom: 50,
                }}
              >
                <div
                  className="hidethis"
                  style={{
                    paddingBottom: 35,
                    backgroundColor: "rgb(247, 247, 247)",
                    width: "200%",
                    marginLeft: -35,
                  }}
                ></div>
                <h3
                  style={{
                    padding: 20,
                    textAlign: "center",
                    borderBottom: "1px solid grey",
                  }}
                >
                  Materialer
                </h3>
                <Materiel
                  addMateriel={(suggestion) => {}}
                  rows={this.props.usage}
                  materielsKey={this.props.usageKey}
                  materiels={this.props.materiels}
                  type="Materiale"
                  update={(materiel, index) =>
                    this.props.dispatch(actions.updateMateriel(materiel, index))
                  }
                  productDiscounts={this.props.productDiscounts}
                  noPopup
                />
              </div>
            ) : null}

            {this.props.measurements && this.props.measurements.length > 0 ? (
              <div
                style={{
                  width: "100%",
                  pageBreakBefore: "auto",
                  pageBreakInside: "avoid",
                  paddingBottom: 50,
                }}
              >
                <div
                  className="hidethis"
                  style={{
                    paddingBottom: 35,
                    backgroundColor: "rgb(247, 247, 247)",
                    width: "200%",
                    marginLeft: -35,
                  }}
                ></div>
                <h3
                  style={{
                    padding: 20,
                    textAlign: "center",
                    borderBottom: "1px solid grey",
                  }}
                >
                  Opmåling
                </h3>
                <Measurements
                  rows={this.props.measurements}
                  measurementsKey={this.props.measurementsKey}
                  update={(measurement, index) =>
                    this.props.dispatch(
                      actions.updateMeasurement(measurement, index)
                    )
                  }
                />
              </div>
            ) : null}

            {this.props.deliveryNotes && this.props.deliveryNotes.length > 0 ? (
              <div
                style={{
                  width: "100%",
                  pageBreakBefore: "auto",
                  pageBreakInside: "avoid",
                  paddingBottom: 50,
                }}
              >
                <div
                  className="hidethis"
                  style={{
                    paddingBottom: 35,
                    backgroundColor: "rgb(247, 247, 247)",
                    width: "200%",
                    marginLeft: -35,
                  }}
                ></div>
                <h3
                  style={{
                    padding: 20,
                    textAlign: "center",
                    borderBottom: "1px solid grey",
                  }}
                >
                  Følgesedler
                </h3>
                <DeliveryNotes
                  update={(deliveryNote, index) =>
                    this.props.dispatch(
                      actions.updateDeliveryNote(deliveryNote, index)
                    )
                  }
                  rows={this.props.deliveryNotes}
                  deliveryNotesKey={this.props.deliveryNotesKey}
                />
              </div>
            ) : null}
            {this.props.others && this.props.others.length > 0 ? (
              <div
                style={{
                  width: "100%",
                  pageBreakBefore: "auto",
                  pageBreakInside: "avoid",
                  paddingBottom: 50,
                }}
              >
                <div
                  className="hidethis"
                  style={{
                    paddingBottom: 35,
                    backgroundColor: "rgb(247, 247, 247)",
                    width: "200%",
                    marginLeft: -35,
                  }}
                ></div>
                <h3
                  style={{
                    padding: 20,
                    textAlign: "center",
                    borderBottom: "1px solid grey",
                  }}
                >
                  Diverse
                </h3>
                <Others
                  id={this.props.othersId}
                  rows={this.props.others}
                  offersKey={this.props.othersKey}
                  update={(index, offer) =>
                    this.props.dispatch(actions.updateOthersRow(index, offer))
                  }
                />
              </div>
            ) : null}
            {this.props.invoices && this.props.invoices.length > 0 ? (
              <div
                style={{
                  width: "100%",
                  pageBreakBefore: "auto",
                  pageBreakInside: "avoid",
                  paddingBottom: 50,
                }}
              >
                <div
                  className="hidethis"
                  style={{
                    paddingBottom: 35,
                    backgroundColor: "rgb(247, 247, 247)",
                    width: "200%",
                    marginLeft: -35,
                  }}
                ></div>
                <h3
                  style={{
                    padding: 20,
                    textAlign: "center",
                    borderBottom: "1px solid grey",
                  }}
                >
                  Bilag
                </h3>
                <Invoices
                  update={(invoice, index) =>
                    this.props.dispatch(actions.updateInvoice(invoice, index))
                  }
                  rows={this.props.invoices}
                  updateBilag={(bilag, index) =>
                    this.props.dispatch(actions.updateBilag(bilag, index))
                  }
                  print
                />
              </div>
            ) : null}
            {this.state.showDailyreports ? (
              <div style={{ paddingTop: 20 }}>
                <div
                  className="hidethis"
                  style={{
                    paddingBottom: 35,
                    backgroundColor: "rgb(247, 247, 247)",
                    width: "200%",
                    marginLeft: -35,
                    paddingTop: 20,
                  }}
                ></div>
                {this.props.dailyreports
                  .sort(function (a, b) {
                    return new Date(b.date) - new Date(a.date);
                  })
                  .map((d, index) => {
                    if (this.props.blacklistedDailyreports[d.aggregateId]) {
                      return;
                    }
                    return (
                      <div
                        key={index}
                        style={{
                          display: "block",
                          pageBreakBefore: "always",
                          paddingTop: 20,
                        }}
                      >
                        <StaticDailyReport
                          pics={d.images}
                          date={new Date(d.date)}
                          stamdata={this.props.workplace}
                          workplaceId={this.props.workplaceId}
                          dailyReportId={d.aggregateId}
                          measurements={d.measurementRegistrations}
                          deliveryNotes={d.deliveryNotes}
                          checkInCheckOutMode={d.checkInCheckOutMode}
                          description={d.description}
                          remark={d.remark}
                          employees={d.employeeRegistrations}
                          activities={d.activityRegistrations}
                          materiels={this.props.materiels}
                          materielRegistrations={d.materielRegistrations}
                        />
                        {d.remrem ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              pageBreakInside: "avoid",
                            }}
                          >
                            <div
                              style={{
                                width: "21cm",
                                paddingTop: 15,
                              }}
                            >
                              <div
                                style={{
                                  backgroundColor: "rgb(205, 214, 219)",
                                  textIndent: 5,
                                  fontWeight: 600,
                                }}
                              >
                                Bemærkning til bygherre
                              </div>
                              <textarea
                                placeholder="..."
                                style={{
                                  "-webkit-appearance": "none",
                                  textIndent: 5,
                                  display: "block",
                                  border: "none",
                                  height: "55px",
                                  width: "100%",
                                  resize: "none",
                                  borderRadius: "2px",
                                }}
                                value={d.remrem}
                                readOnly
                              ></textarea>
                            </div>
                          </div>
                        ) : null}
                        <div
                          className="hidethis"
                          style={{
                            paddingBottom: 35,
                            backgroundColor: "rgb(247, 247, 247)",
                            width: "200%",
                            marginLeft: -35,
                            paddingTop: 20,
                          }}
                        ></div>
                      </div>
                    );
                  })}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

const isMas = process.env.REACT_APP_title.includes("Mas");
var styles = {
  container: {
    height: "100%",
    position: "relative",
    visibility: "visible",
    width: "100%",
  },
  img: {
    margin: "0 auto",
    display: "block",
  },
  innerContainer: {
    height: "auto",
    padding: "0",
  },
  contentContainer: {
    width: "100%",
    height: "auto",
    display: "block",
    margin: "0 auto",
    padding: "10px 25px",
    marginBottom: "0.5cm",
    backgroundColor: "white",
  },
  sideLinesContainer: {
    height: "100%",
    width: "100%",
    position: "absolute",
    top: "0",
    left: "0",
    padding: "30px 0",
  },
  sideLines: {
    height: "100%",
    borderLeft: "2px solid " + semanticColors.mainBackground,
    borderRight: "2px solid " + semanticColors.mainBackground,
  },
  doubleLine: {
    borderBottom: "4px double " + semanticColors.mainBackground,
    lineHeight: "1.2em",
    margin: "0",
    padding: "4px 0",
  },
  entityContainer: {
    marginBottom: "20px",
  },
  contentPadding: {
    padding: "0 4px",
  },
  heading: {
    left: {
      float: "left",
    },
    right: {
      float: "right",
      fontSize: "12px",
    },
  },
  stamdata: {
    row: {
      borderBottom: "1px solid " + semanticColors.mainBackground,
      margin: "0",
      paddingLeft: "4px",
      lineHeight: "25px",
    },
    col: {
      paddingLeft: "0",
    },
  },
  employee: {
    container: {
      border: "1px solid " + semanticColors.mainBackground,
      borderRadius: "2px",
      marginTop: "6px",
      padding: "6px 4px 0 4px",
    },
    headingRow: {
      height: "15px",
      lineHeight: "15px",
      textAlign: "center",
      fontSize: "12px",
      margin: "0",
    },
    row: {
      height: "23px",
      lineHeight: "23px",
      borderBottom: "1px solid " + semanticColors.mainBackground,
      padding: "0",
      textAlign: "center",
      margin: "0 6px 6px 6px",
    },
    left: {
      textAlign: "left",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
    middle: {},
    right: {
      textAlign: "right",
    },
    notLastTimeRegistration: {
      margin: "0 6px 0px 6px",
    },
    noBorder: {
      borderBottom: "none",
      margin: "0 6px 6px 6px",
    },
  },
  signature: {
    container: {
      height: "120px",
      width: "100%",
      position: "relative",
    },
    dateContainer: {
      borderBottom: "1px solid " + semanticColors.mainBackground,
      float: "left",
      width: "30%",
      position: "absolute",
      top: "95px",
    },
    imageContainer: {
      borderBottom: "1px solid " + semanticColors.mainBackground,
      float: "right",
      width: "66%",
      position: "relative",
    },
    image: {
      width: "380px",
      height: "100px",
    },
    name: {
      position: "absolute",
    },
  },
  activity: {
    row: {
      borderBottom: "1px solid " + semanticColors.mainBackground,
      margin: "0",
      paddingLeft: "4px",
      height: "100%",
      lineHeight: "25px",
      overflow: "auto",
    },
    left: {
      textAlign: "left",
      float: "left",
    },
    right: {
      textAlign: "right",
      float: "right",
    },
  },
  noPadding: {
    padding: "0px",
  },
  deliveryNotes: {
    row: {
      borderBottom: "1px solid " + semanticColors.mainBackground,
      margin: "0",
      paddingLeft: "4px",
      lineHeight: "25px",
    },
    col: {
      paddingLeft: "0",
    },
    heading: {
      marginBottom: "10px",
    },
  },
  usage: {
    heading: {
      marginBottom: "10px",
    },
    row: {
      borderBottom: "1px solid " + semanticColors.mainBackground,
      margin: "0",
      paddingLeft: "4px",
      height: "25px",
      lineHeight: "25px",
    },
    left: {
      textAlign: "left",
      padding: "0",
    },
    right: {
      textAlign: "right",
      padding: "0",
    },
    middle: {
      textAlign: "center",
      padding: "0",
    },
  },
  measurements: {
    heading: {
      marginBottom: "10px",
    },
    headingRow: {
      lineHeight: "1.3em",
    },
    row: {
      borderBottom: "1px solid " + semanticColors.mainBackground,
      margin: "0",
      paddingLeft: "4px",
      lineHeight: "25px",
    },
    headingPadding: {
      paddingTop: "18px",
    },
    firstColumn: {
      width: "21%",
      paddingRight: "12px",
      paddingLeft: "0",
      float: "left",
    },
    secondColumn: {
      width: "12%",
      paddingRight: "12px",
      paddingLeft: "0",
      float: "left",
      textAlign: "right",
    },
    thirdColumn: {
      width: "20%",
      paddingRight: "12px",
      paddingLeft: "0",
      float: "left",
      textAlign: "right",
    },
    forthColumn: {
      width: "12%",
      paddingRight: "12px",
      paddingLeft: "0",
      float: "left",
      textAlign: "right",
    },
    fifthColumn: {
      width: "35%",
      paddingRight: "12px",
      paddingLeft: "0",
      float: "left",
    },
  },
  translateSmallText: {
    fontSize: "12px",
    fontWeight: "600",
  },
  firstRow: {
    padding: "30px 0px 4px 0px",
  },
  date: {
    marginLeft: "10px",
  },
  logo: {
    width: isMas ? "200px" : "90px",
    height: "45px",
    float: "right",
  },
};

const selectProps = (state) => {
  return {
    ...state.TilbudReducer,
  };
};

export default connect(selectProps)(Radium(StaticInvoice));



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Tilbud/staticInvoice.js